import React, { Component } from 'react'
import { connect } from 'react-redux'
import { aclPermissions, hasPermissions } from 'const/ACLPermissions'
import cookie from 'react-cookies'
import { getUnauthorizedComponent } from 'component/dashboard/slidelist_utils'
import ManageUsers from './manageusers'

import 'asset/style/scanner/scanner.css'
import 'asset/style/settings/manageusers/manageusers.css'
import 'asset/style/accesscontrol.css'

const AccessControlViews = {
    user: {
        name: 'user',
        title: 'Users',
        url: '/user_access_control',
        hasAccess: (permissions) => hasPermissions([aclPermissions.manage_users_menu])
    },
    // policy: {
    //     name: 'policy',
    //     title: 'Policies',
    //     url: '/policy_access_control',
    //     hasAccess: (permissions) => hasPermissions([aclPermissions.view_policy])
    // },
}

const getDefaultAccessView = (permissions) =>
    Object.entries(AccessControlViews).find(([_, obj]) => obj.hasAccess(permissions))?.[0]

class AccessControl extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currView: getDefaultAccessView(cookie.load('access_permissions')) || null,
        }
    }

    render() {
        return hasPermissions([aclPermissions.manage_users_menu]) ?
            (<ManageUsers />) :
            (<div>{getUnauthorizedComponent()}</div>)
    }
}

const mapStateToProps = state => {
    return {

    }
}

export default connect(mapStateToProps)(AccessControl)